import { tv, type VariantProps } from 'tailwind-variants';
export type OrMiniCtaBlockVariants = VariantProps<typeof orMiniCtaBlockA>;

const orMiniCtaBlockA = tv({
  slots: {
    base: '',
    contents:
      'container w-full rounded-30 py-12 lg:py-62 flex flex-col items-start lg:flex-row lg:justify-center lg:items-center gap-6',
    iconContainer: 'lg:pt-1 text-40 h-full min-h-full',
    iconColor: '',
    descriptionContainer: '',
    title: '',
  },
  variants: {
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
    hasDescription: {
      true: {
        title: 'lg:text-balance',
      },
      false: {
        title: 'w-full',
      },
    },
    hasTitle: {
      true: {
        descriptionContainer: 'text-left  max-w-570',
      },
      false: {
        descriptionContainer: 'text-left lg:text-center',
      },
    },
    theme: {
      light: {
        iconColor: 'var(--color-ui-icon-secondary)',
        contents: '!bg-skin-secondary',
        descriptionContainer: 'text-skin-primary',
      },
      dark: {
        iconColor: 'var(--color-ui-fill-tertiary)',
        contents: '',
        descriptionContainer: 'text-skin-tertiary',
      },
    },
  },
  compoundVariants: [],
});

export default orMiniCtaBlockA;
